import { useInfiniteQuery } from '@tanstack/react-query';
import { parse } from 'query-string';
import { useLocation, useParams } from 'react-router-dom';

import { callGetCollectionTokenList } from '@app/client/resources/marketplace';
import { PathParams } from '@app/routes/types';

export type CollectionTokensQueryParams = {
    sortBy?: string;
    sortDirection?: 'asc' | 'desc';
    minRarityRank?: string;
    maxRarityRank?: string;
};

type UseDaasGetCollectionTokensProps = {
    slug?: string;
    limit?: number;
    disabled?: boolean;
    ignoreSignal?: boolean;
};

export const useDaasGetCollectionTokens = (props?: UseDaasGetCollectionTokensProps) => {
    const { limit, slug, disabled, ignoreSignal } = props || {};
    const { [PathParams.CollectionSlug]: collectionSlugParam } = useParams();

    const collectionSlug = slug || collectionSlugParam || '';

    const location = useLocation();

    const query: CollectionTokensQueryParams = parse(location.search);
    if (!query.sortDirection) {
        query.sortDirection = 'asc';
    }

    // TODO: add filters once ready
    // const queryCache = Object.keys(query).map((queryKey) => `${queryKey}=${query[queryKey]}`);

    const finalLimit = limit || 20;
    const cache = ['collectionPageTokens-daas', slug, finalLimit];

    return useInfiniteQuery(
        cache,
        ({ signal, pageParam }) =>
            callGetCollectionTokenList({
                slug: collectionSlug,
                query: {
                    limit: finalLimit,
                    ...(pageParam ? { continuation: pageParam } : {}),
                },
                settings: {
                    signal: ignoreSignal ? undefined : signal,
                },
            }),
        {
            retry: true,
            keepPreviousData: true,
            enabled: Boolean(collectionSlug) && !disabled,
            getNextPageParam: (params) => params.continuation,
        },
    );
};
